export default "__VITE_ASSET__DgT73FMU__"